module.exports = __webpack_public_path__ + "static/media/dotNet.e5a6c1ab.png";